import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { ToastType } from '@components/Toast';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

import { ClaimDataType } from './types';

export const getClaimDataApi = async (id: number) => {
  try {
    const data: V4ApiResponse<ClaimDataType> = await apiClient.get(
      `/Claim/${id}`,
    );
    if ('value' in data) {
      return data.value;
    }
  } catch (error) {
    const e = createError(error, 'Unable to fetch Claim data');
    handleToast(ToastType.Error, e.message);
  }
};

export const saveClaimApi = async (
  payload: ClaimDataType,
  changeTrackingSources: readonly ChangeTrackingSource[] = [],
) => {
  try {
    const response: V4ApiResponse<ClaimDataType> = await apiClient.post(
      '/Claim',
      payload,
      buildChangeTrackingRequestConfig(changeTrackingSources),
    );
    if (response.isSuccess) {
      handleToast(ToastType.Success, 'Claim was saved');
    }
    return response;
  } catch (e: unknown) {
    const error = createError(e, 'Unable to save claim');
    handleToast(ToastType.Error, error.message);
  }
};
